module["exports"] = {
  "descriptor": [
    "Líder",
    "Senior",
    "Direto",
    "Corporativo",
    "Dinâmico",
    "Futuro",
    "Produto",
    "Nacional",
    "Regional",
    "Distrito",
    "Central",
    "Global",
    "Cliente",
    "Investidor",
    "Dinâmico",
    "International",
    "Legado",
    "Avançar",
    "Interno",
    "Humano",
    "Chefe",
    "Principal"
  ],
  "level": [
    "Soluções",
    "Programa",
    "Marca",
    "Segurança",
    "Pesquisar",
    "Marketing",
    "Diretivas",
    "Implementation",
    "Implementação",
    "Funcionalidade",
    "Resposta",
    "Paradigma",
    "Táticas",
    "Identidade",
    "Mercados",
    "Grupo",
    "Divisão",
    "Aplicações",
    "Otimização",
    "Operações",
    "Infraestrutura",
    "Intranet",
    "Comunicações",
    "Web",
    "Branding",
    "Qualidade",
    "Assurance",
    "Mobilidade",
    "Contas",
    "Dados",
    "Criativo",
    "Configuration",
    "Prestação de contas",
    "Interações",
    "Fatores",
    "Usabilidade",
    "Métricas"
  ],
  "job": [
    "Supervisor",
    "Associado",
    "Executivo",
    "Atentende",
    "Policial",
    "Gerente",
    "Engenheiro",
    "Especialista",
    "Diretor",
    "Coordenador",
    "Administrador",
    "Arquiteto",
    "Analista",
    "Designer",
    "Planejador",
    "Orquestrador",
    "Técnico",
    "Desenvolvedor",
    "Produtor",
    "Consultor",
    "Assistente",
    "Facilitador",
    "Agente",
    "Representante",
    "Estrategista"
  ]
};
